export interface ICancerRejectionList {
    id: number;
    remission: number;
}
